import {onBeforeUnmount, onMounted, ref, unref} from 'vue';
import Hammer from 'hammerjs';

export const useSwipeGesture = ({target, threshold, disabled, onCommit}) => {
  const translateX = ref(0);
  const isLiked = ref(false);
  const isDisliked = ref(false);
  const isAnimateLiked = ref(false);
  const isAnimateDisliked = ref(false);
  const isPanning = ref(false);
  let manager = null;

  const reset = () => {
    translateX.value = 0;
    isLiked.value = false;
    isDisliked.value = false;
    isAnimateLiked.value = false;
    isAnimateDisliked.value = false;
    isPanning.value = false;
  };

  const handlePanMove = (event) => {
    if (unref(disabled)) {
      reset();
      return;
    }

    const deltaX = event.deltaX;
    const commitThreshold = unref(threshold);

    translateX.value = deltaX;
    isLiked.value = deltaX > 0;
    isDisliked.value = deltaX < 0;
    isAnimateLiked.value = deltaX >= commitThreshold;
    isAnimateDisliked.value = deltaX <= -commitThreshold;
    isPanning.value = true;
  };

  const handlePanEnd = (event) => {
    if (!unref(disabled)) {
      const commitThreshold = unref(threshold);

      if (event.deltaX >= commitThreshold) {
        onCommit(true);
      } else if (event.deltaX <= -commitThreshold) {
        onCommit(false);
      }
    }

    reset();
  };

  onMounted(() => {
    if (target.value === null) {
      return;
    }

    manager = new Hammer.Manager(target.value);
    manager.add(new Hammer.Pan({
      direction: Hammer.DIRECTION_HORIZONTAL,
      threshold: 5,
    }));
    manager.on('panmove', handlePanMove);
    manager.on('panend', handlePanEnd);
    manager.on('pancancel', reset);
  });

  onBeforeUnmount(() => {
    if (manager !== null) {
      manager.destroy();
      manager = null;
    }
  });

  return {
    translateX,
    isLiked,
    isDisliked,
    isAnimateLiked,
    isAnimateDisliked,
    isPanning,
    reset,
  };
};
